<script setup lang="ts">
import { formatRowDate, formatRowDateOnly, type TransactionTableRow } from '@peanuds/shared';

const { row, dateOnly = false } = defineProps<{
  row: TransactionTableRow;
  dateOnly?: boolean;
}>();
</script>

<template>
  <span class="cell-date">{{ dateOnly ? formatRowDateOnly(row) : formatRowDate(row) }}</span>
</template>
